import { createElementVNode as _createElementVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, normalizeClass as _normalizeClass, createCommentVNode as _createCommentVNode, Transition as _Transition, withCtx as _withCtx, createBlock as _createBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-711c8bb0"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "WalletsPopup-panel" }
const _hoisted_2 = ["onClick"]
const _hoisted_3 = ["data-icon", "disabled"]
const _hoisted_4 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("em", null, null, -1))

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createBlock(_Transition, {
    name: "WalletsPopupTransition",
    appear: ""
  }, {
    default: _withCtx(() => [
      _createElementVNode("aside", {
        class: _normalizeClass(["WalletsPopup", { isLoading: _ctx.isLoading }])
      }, [
        _createElementVNode("div", {
          class: "WalletsPopup-overlay",
          onClick: _cache[0] || (_cache[0] = 
//@ts-ignore
(...args) => (_ctx.close && _ctx.close(...args)))
        }),
        _createElementVNode("div", _hoisted_1, [
          _createElementVNode("ul", null, [
            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.providersList, (item) => {
              return (_openBlock(), _createElementBlock("li", {
                key: item,
                onClick: ($event: any) => (_ctx.onProviderClick(item))
              }, [
                _createElementVNode("button", {
                  "data-icon": item,
                  disabled: _ctx.isLoading,
                  class: _normalizeClass({ showLoader: _ctx.isLoading && _ctx.loadingProviderName === item })
                }, [
                  _createTextVNode(_toDisplayString(_ctx.$t(`providers.${item}`)), 1),
                  _hoisted_4
                ], 10, _hoisted_3)
              ], 8, _hoisted_2))
            }), 128))
          ]),
          (!_ctx.uncancellable)
            ? (_openBlock(), _createElementBlock("button", {
                key: 0,
                class: "WalletsPopup-panelClose",
                onClick: _cache[1] || (_cache[1] = 
//@ts-ignore
(...args) => (_ctx.close && _ctx.close(...args)))
              }))
            : _createCommentVNode("", true)
        ])
      ], 2)
    ]),
    _: 1
  }))
}